import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaSearchPlus, FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet-async";

const Collection = () => {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  // Preloader timer
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {

    setLoading(true);   // loader start

    axios
      .get(`https://kskrishnasilver.com/api/products.php?category=${slug}`)
      .then((res) => {
        if (res.data.status) {
          setProducts(res.data.data);
        } else {
          setProducts([]);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoading(false);   // loader stop
      });

  }, [slug]);

  const closeModal = () => setSelectedIndex(null);
  const nextImage = () =>
    setSelectedIndex((prev) => (prev + 1) % products.length);
  const prevImage = () =>
    setSelectedIndex((prev) =>
      prev === 0 ? products.length - 1 : prev - 1
    );

    useEffect(() => {
  products.forEach(product => {
    const img = new Image();
    img.src = product.image;
  });
}, [products]);

  return (
    <>
      {loading && (
        <div className="loader-wrapper">
          <div className="ring-loader"></div>
        </div>
      )}
      <Header />
      <Helmet>
        <title>
          {`Collection | Krishna Silver | ${process.env.REACT_APP_PHONE}`}
        </title>
      </Helmet>

      <div className="collection-page" >
        <div className="collection-hero">
          <h1><Link to="/">Home</Link> <span> ~ </span> <Link to="/collections">Our Collections</Link> <span> ~ </span> <Link className="activepage" to={`/collection/${slug}`}> {slug.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())}</Link></h1>
        </div>
      </div>

      {products.length > 0 ? (
        <div className="container">
        <div className="product-grid">
          {products.map((item, index) => (
            <div className="product-card" key={item.id}>
              <div
                className="image-wrapper"
                onClick={() => setSelectedIndex(index)}
              >
                <img src={item.image} alt={item.name} loading="lazy" />
                <div className="overlay">
                  <FaSearchPlus className="icon" />
                </div>
              </div>
            </div>
          ))}
        </div>
         </div>

      ) : (

        <div className="no-products">
          <h2>No Products Found</h2>
          <p>This category does not have any products yet.</p>
        </div>

      )}

      {/* MODAL */}
      {selectedIndex !== null && (
        <div className="modal">
          <FaTimes className="close" onClick={closeModal} />
          <FaChevronLeft className="left" onClick={prevImage} />
          <img
            src={products[selectedIndex].image}
            alt="zoom"
            className="modal-img"
          />
          <FaChevronRight className="right" onClick={nextImage} />
        </div>
      )}
      <Footer />
    </>
  );
};

export default Collection;